var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#32373A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9941 59.9997C69.5382 59.9997 77.2752 52.8363 77.2752 43.9998C77.2752 35.1634 69.5382 28 59.9941 28C50.45 28 42.713 35.1634 42.713 43.9998C42.713 52.8363 50.45 59.9997 59.9941 59.9997Z",
    fill: "#E1D9CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64.5717C43.1059 64.5717 29.2606 76.6574 28 92H92C90.7394 76.6574 76.8941 64.5717 60 64.5717Z",
    fill: "#E1D9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserfull);
export default __webpack_public_path__ + "static/media/userfull.d2ea7ee5d0deaa9c8e8a8f58b46f92ee.svg";
export { ForwardRef as ReactComponent };